
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent, ref} from 'vue';
import Popper from "vue3-popper";

export default defineComponent({
    name: "SectorMap",
    components: {
        Popper
    },
    props: {

    },
    setup(props, { emit }) {
        const activeSector = ref(null);

        const legend = [
            {
                title: "Adelboden-Lenk",
                color: "#0069B4",
            },
            {
                title: "Elsigen-Metsch",
                color: "#FEF8C7",
            },
            {
                title: "Betelberg",
                color: "#AFCA0A",
            },
            {
                title: "Engstligenalp",
                color: "#DF91A9",
            },
            {
                title: "Silleren-Chuenisbärgli",
                color: "#906AAA",
            },
            {
                title: "Tschentenalp",
                color: "#EF7E03",
            }
        ];

        const sectorStyle = (color: string) => {
            return {
                backgroundColor: color,
            }
        }

        return {
            legend,
            sectorStyle,
            activeSector,
            translate,
        }
    }
})
